import { USER_PERMISSION } from '~/consts/user';
import { getStore } from '~/mobx/AppStore';

const getIsSuperAdmin = (): boolean => {
    const { userStore } = getStore();
    return userStore.user?.permissions.includes(USER_PERMISSION.SUPER_ADMIN) || false;
};

export default getIsSuperAdmin;
